import React, { useState, useEffect } from 'react';
import classes from './style/EditTheme.module.css';
import { Button, Form, Input, Select, Space, Popconfirm, UploadProps, Upload } from 'antd';
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ApiCenter } from '../../api/ApiCenter';
import { useNavigate, useParams } from 'react-router-dom';
import { UI_Footer } from '../../../Core/Core';

interface Theme {
  id: number;
  title: string;
  description?: string;
  video?: string;
  video_link?: string;
  lesson_order: number;
}
interface IonFinishTheme {
  title: string;
  category_id: string;
  Theme: Theme[];
}
interface ILesson {
  id: number;
  title: string;
  description?: string;
  video?: string;
  video_link?: string;
  video_path?: string;
  lesson_order: number;
}
interface ItransformedData {
  theme: {
    title: string;
    category_id: string;
    is_draft: boolean;
  };
  lessons: ILesson[];
}
const EditTheme = () => {
  const ApiStart = new ApiCenter();
  const navigate = useNavigate();
  const { id } = useParams();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [draft, setDraft] = useState(false);
  const [data, setData] = useState<ItransformedData>();
  const [uploading, setUploading] = useState<number[]>([]);
  const sotrLessons = (lessons: ILesson[]) => {
    const localDate = lessons
      .sort((itemA: ILesson, itemB: ILesson) => itemA.lesson_order - itemB.lesson_order)
      .map((item: ILesson, index: number) => {
        return {
          ...item,
          lesson_order: index + 1,
          video: item.video || item.video_link,
        };
      });
    return localDate;
  };
  const geters = () => {
    ApiStart.GET_API(`hr/theme/${id}`, 'GET').then((res) => {
      if (res.success as ItransformedData) {
        const localDate = sotrLessons(res.data.lessons);
        form.setFieldValue('title', res.data.theme.title);
        form.setFieldValue('category_id', res.data.theme.category_id);
        form.setFieldValue('Theme', localDate);
        setData({
          theme: res.data.theme,
          lessons: localDate,
        });
      } else {
        alert(res.message);
      }
    });
  };
  useEffect(() => {
    geters();
  }, []);
  if (!data) {
    return null;
  }

  const createUploadProps = (idlessons: number, index: number): UploadProps => {
    return {
      showUploadList: false,
      beforeUpload: (file) => {
        const formFileData = new FormData();
        formFileData.append('file', file);
        setUploading((prev) => [...prev, index]);

        // Отправка файла
        ApiStart.GET_API(`hr/theme/video-upload/${idlessons}`, 'POST', formFileData)
          .then((res) => {
            // Обработка успешного ответа
            formFileData.delete('file');
          })
          .catch((error) => {
            // Обработка ошибки
            formFileData.delete('file');
          })
          .finally(() => {
            formFileData.delete('file');
            setUploading((prev) => prev.filter((i) => i !== index));
          });
        return false;
      },
    };
  };
  const onFinish = (values: IonFinishTheme) => {
    const transformedData: ItransformedData = {
      theme: {
        title: values.title,
        category_id: values.category_id,
        is_draft: draft,
      },
      lessons: values.Theme.map((theme: ILesson, index: number) => {
        const lesson = {
          id: theme.id,
          title: theme.title,
          description: theme.description,
          video: theme.video,
          video_link: theme.video,
          lesson_order: index + 1,
        };
        return lesson;
      }),
    };

    ApiStart.GET_API(`hr/theme/${id}`, 'PUT', transformedData).then((res) => {
      if (res.success) {
        navigate('/education');
      } else {
        alert(res.message);
      }
    });
  };
  const draftSave = (param: boolean): void => {
    setDraft(param);
    form.submit();
  };
  const confirmOffPage = () => {
    navigate('/education');
  };

  const getTransformedData = (name: number) => {
    const transformedData = {
      theme: {
        title: data.theme.title,
        category_id: data.theme.category_id,
        is_draft: draft,
      },
      lessons: data.lessons.map((theme) => {
        if (theme.id === name) {
          return {
            id: theme.id,
          };
        } else {
          return {
            id: theme.id,
            title: theme.title,
            description: theme.description,
            video: theme.video,
            video_link: theme.video,
            lesson_order: theme.lesson_order,
          };
        }
      }),
    };
    return transformedData;
  };
  const deleteLesson = (name: number) => {
    ApiStart.GET_API(`hr/theme/${id}`, 'PUT', getTransformedData(name)).then((res) => {
      if (res.success) {
        setData({
          theme: data.theme,
          lessons: data.lessons
            .filter((item) => item.id !== name)
            .map((item: ILesson, index: number) => {
              return {
                ...item,
                lesson_order: index + 1,
              };
            }),
        });
      } else {
        alert(res.message);
      }
    });
  };
  return (
    <div className={classes.Wrapper}>
      <div className={classes.HeaderNav}>
        <div className={classes.HeaderTitle}>
          <h2>Редактирование темы</h2>
        </div>
        <div className={classes.HeaderButtonBack}>
          <Popconfirm
            placement="right"
            title={'Закрыть создание теста'}
            onConfirm={confirmOffPage}
            okText="Да Закрыть"
            cancelText="Продолжить создание теста"
          >
            <CloseOutlined />
          </Popconfirm>
        </div>
      </div>
      <Form form={form} name="EditTheme" onFinish={onFinish} autoComplete="off" layout="vertical">
        <Form.Item label="Название темы" name="title">
          <Input />
        </Form.Item>
        <div className={classes.themeName}>
          <Form.Item style={{ width: 450 }} label="Категория урока" name="category_id">
            <Select placeholder="Категория урока">
              <Option value={2}>Продажи</Option>
              <Option value={3}>Кредитование</Option>
              <Option value={4}>HR</Option>
              <Option value={5}>IT</Option>
            </Select>
          </Form.Item>
          <div style={{ color: '#888' }}>
            Выберите категорию для дальнейшей сортировки тем на странице.
          </div>
        </div>
        <Form.List name="Theme">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index: number) => {
                const confirmDeleteLesson = () => {
                  deleteLesson(data.lessons[index].id);
                  remove(name);
                };
                return (
                  <Space key={key} style={{ display: 'block', marginBottom: 8 }} align="baseline">
                    <div className={classes.WrapperLissensIndex}>
                      <div>Урок {index + 1}</div>
                      <div>
                        <Popconfirm
                          placement="right"
                          title={'Удалить урок ?'}
                          onConfirm={confirmDeleteLesson}
                          okText="Да удалить урок"
                          cancelText="Отмена"
                        >
                          <Button>
                            Удалить урок <DeleteOutlined />
                          </Button>
                        </Popconfirm>
                      </div>
                    </div>

                    <Form.Item
                      {...restField}
                      name={[name, 'title']}
                      rules={[{ required: true, message: 'Введите название урока' }]}
                      label="Название урока"
                    >
                      <Input placeholder="Введите название урока" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'description']}
                      rules={[{ required: false, message: 'Missing first name' }]}
                      label="Описание урока"
                      style={{ height: 370 }}
                    >
                      <ReactQuill style={{ height: 300 }} />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'video']}
                      rules={[{ required: false, message: 'Missing last name' }]}
                      label="Ссылка на видео"
                    >
                      <Upload {...createUploadProps(data?.lessons[index]?.id, index)}>
                        <Button loading={uploading.includes(index)}>
                          {data?.lessons[index]?.video_path
                            ? data?.lessons[index]?.video_path
                            : 'Загрузить '}
                        </Button>
                      </Upload>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'lesson_order']}
                      initialValue={index + 1}
                    >
                      <Input type="hidden" />
                    </Form.Item>
                    {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                  </Space>
                );
              })}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block>
                  + Добавить урок
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <UI_Footer>
          <div>
            <Button onClick={() => draftSave(true)}>Переместить в черновик</Button>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Button type="primary" onClick={() => draftSave(false)}>
              Сохранить тему
            </Button>
          </div>
        </UI_Footer>
      </Form>
    </div>
  );
};

export default EditTheme;
